export function fileCollectionFromPaths() {
    throw new Error('This method is not available in the browser');
}
//# sourceMappingURL=fileCollectionFromPaths.browser.js.map